import { DonorStatus } from 'gql/types';

export const DONOR_STATUSES_NOT_ALLOWED_TO_AUTOMATE = [
  DonorStatus.Retired,
  DonorStatus.Archived,
  DonorStatus.NotAccepted,
];

export const NOT_ACTIVE_DONOR_STATUES = [
  DonorStatus.Retired,
  DonorStatus.Archived,
  DonorStatus.NotAccepted,
];

export const DONOR_STATUSES_WITH_NO_AGE_VALIDATION = [DonorStatus.Affiliate];

const DONOR_STATUSES_NOT_ALLOWED_TO_AUTO_RETIRE = [
  ...DONOR_STATUSES_NOT_ALLOWED_TO_AUTOMATE,
  ...DONOR_STATUSES_WITH_NO_AGE_VALIDATION,
];

function allStatuses() {
  return Object.values(DonorStatus);
}

function excluding(list: DonorStatus[]) {
  return allStatuses().filter((s) => !list.includes(s));
}

export function getDonorStatusesAllowedToAutomate() {
  return excluding(DONOR_STATUSES_NOT_ALLOWED_TO_AUTOMATE);
}

export function isAllowedToAutomateDonorStatus(status: DonorStatus) {
  return !DONOR_STATUSES_NOT_ALLOWED_TO_AUTOMATE.includes(status);
}

export function isAllowedToValidateDonorAge(status: DonorStatus) {
  return !DONOR_STATUSES_WITH_NO_AGE_VALIDATION.includes(status);
}

export function getDonorStatusesAllowedToAutoRetire() {
  return excluding(DONOR_STATUSES_NOT_ALLOWED_TO_AUTO_RETIRE);
}

export function isDonorAllowedToAutoRetire(status: DonorStatus) {
  return !DONOR_STATUSES_NOT_ALLOWED_TO_AUTO_RETIRE.includes(status);
}

export function getNotActiveDonorStatuses() {
  return NOT_ACTIVE_DONOR_STATUES;
}
